// extracted by mini-css-extract-plugin
export default {"containers":"order_containers__x4E5n","orders_container":"order_orders_container__zR6h9"};